import { get, isFunction } from "radashi";
import { EngineVector, isVector, toArray } from "../vector";

export type Deletable = { delete: () => void };

export function deleteVector<T extends Deletable>(
  vector: EngineVector<T | undefined>,
) {
  toArray(vector).forEach((item) => {
    if (!item) return;
    const deleteFn = get(item, "delete");
    if (isFunction(deleteFn)) {
      deleteFn.call(item);
    }
  });
}

/**
 * Executes an operation while ensuring that provided entries (either a single
 * vector/object or an array of them) are deleted afterward.
 */
export function withDelete<T extends Deletable | EngineVector, R>(
  entry: T | T[],
  operation: (() => R) | R,
): R {
  try {
    return isFunction(operation) ? (operation as () => R)() : operation;
  } finally {
    if (Array.isArray(entry)) {
      entry.forEach(deleteEntry);
    } else {
      deleteEntry(entry);
    }
  }
}

function deleteEntry<T extends Deletable | EngineVector<Deletable>>(entry: T) {
  return isVector<Deletable>(entry) ? deleteVector(entry) : entry.delete();
}
